/* Roue de la fortune — gl. Genere par roue_kit.py, ne pas editer a la main. */
(function () {
  var VOILE = document.getElementById('gl-roue');
  if (!VOILE) return;

  var CLE = 'gl_roue';
  var GAGNANTES = [1, 4];
  var boite  = VOILE.querySelector('.gl-roue');
  var CODE   = boite.getAttribute('data-code');
  var disque = VOILE.querySelector('.gl-roue__disque g');
  var force  = /[?&]roue=1/.test(window.location.search);
  var ouvert = false, tourne = false;

  function etat() { try { return JSON.parse(localStorage.getItem(CLE) || 'null'); } catch (e) { return null; } }
  function noter(v) { try { localStorage.setItem(CLE, JSON.stringify({ etat: v, t: Date.now() })); } catch (e) {} }

  // Pages ou le pop-up n'a rien a faire.
  function pageInterdite() {
    return /^\/(cart|account|checkouts?|challenge|password|tools)(\/|$)/.test(window.location.pathname);
  }
  function peutOuvrir() {
    if (force) return true;
    if (pageInterdite()) return false;
    var e = etat();
    if (!e) return true;
    if (e.etat === 'gagne') return false;                     // il a son code
    return (Date.now() - (e.t || 0)) > 3 * 24 * 3600 * 1000;  // ferme : on repropose dans 3 jours
  }
  function tiroirOuvert() { return document.documentElement.className.indexOf('gl-tiroir-ouvert') > -1; }

  function ouvrir() {
    if (ouvert || !peutOuvrir() || tiroirOuvert()) return;
    ouvert = true;
    VOILE.classList.add('gl-roue--ouvert');
    document.documentElement.classList.add('gl-roue-bloque');
    document.body.classList.add('gl-roue-bloque');
    VOILE.setAttribute('aria-hidden', 'false');
    setTimeout(function () { try { boite.setAttribute('tabindex', '-1'); boite.focus({ preventScroll: true }); } catch (e) {} }, 340);
  }
  function fermer() {
    ouvert = false;
    VOILE.classList.remove('gl-roue--ouvert');
    document.documentElement.classList.remove('gl-roue-bloque');
    document.body.classList.remove('gl-roue-bloque');
    VOILE.setAttribute('aria-hidden', 'true');
    if (boite.getAttribute('data-etape') !== 'code') noter('ferme');
  }

  // --- declencheurs : 20 secondes, ou un vrai defilement ---
  if (peutOuvrir()) {
    setTimeout(ouvrir, force ? 250 : 20000);
    var auDefilement = function () {
      var h = document.documentElement;
      var avance = h.scrollTop / Math.max(1, h.scrollHeight - h.clientHeight);
      if (h.scrollTop > 700 || avance > 0.3) {
        window.removeEventListener('scroll', auDefilement);
        ouvrir();
      }
    };
    window.addEventListener('scroll', auDefilement, { passive: true });
  }

  VOILE.querySelectorAll('[data-gl-fermer]').forEach(function (b) { b.addEventListener('click', fermer); });
  VOILE.addEventListener('click', function (e) { if (e.target === VOILE) fermer(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && ouvert) fermer(); });

  // --- 1. le tour de roue, sans rien demander ---
  var lancer = VOILE.querySelector('[data-gl-lancer]');
  lancer.addEventListener('click', function () {
    if (tourne) return;
    tourne = true;
    lancer.disabled = true;
    lancer.textContent = lancer.getAttribute('data-en-cours');
    var index  = GAGNANTES[Math.floor(Math.random() * GAGNANTES.length)];
    var centre = index * 45 + 22.5;
    var jeu    = (Math.random() * 22) - 11;        // on ne s'arrete pas pile au milieu
    disque.style.transform = 'rotate(' + (360 * 6 - centre + jeu) + 'deg)';
    setTimeout(function () {
      boite.setAttribute('data-etape', 'gagne');
      noter('gagne');
      setTimeout(function () { try { VOILE.querySelector('.gl-roue__champ').focus(); } catch (e) {} }, 300);
    }, 4700);
  });

  // --- 2. l'e-mail, une fois le lot connu ---
  var champ   = VOILE.querySelector('.gl-roue__champ');
  var envoyer = VOILE.querySelector('[data-gl-envoyer]');
  var erreur  = VOILE.querySelector('.gl-roue__erreur');

  var formulaire = VOILE.querySelector('.gl-roue__formulaire');

  // Le formulaire part vraiment chez Shopify, dans l'iframe cachee : l'adresse est
  // enregistree et l'automatisation d'e-mail peut partir. La page ne bouge pas,
  // donc le code s'affiche a l'ecran dans la foulee.
  if (formulaire) formulaire.addEventListener('submit', function (e) {
    var v = (champ.value || '').trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(v)) {
      e.preventDefault(); erreur.hidden = false; champ.focus(); return;
    }
    erreur.hidden = true;
    envoyer.disabled = true; champ.disabled = true;
    setTimeout(function () { boite.setAttribute('data-etape', 'code'); }, 120);
  });
  champ.addEventListener('input', function () { erreur.hidden = true; });

  // --- 3. le code ---
  var copier = VOILE.querySelector('.gl-roue__copier');
  if (copier) copier.addEventListener('click', function () {
    try { navigator.clipboard.writeText(CODE); } catch (e) {}
    var avant = copier.textContent;
    copier.textContent = copier.getAttribute('data-copie');
    setTimeout(function () { copier.textContent = avant; }, 1800);
  });
  var profiter = VOILE.querySelector('[data-gl-profiter]');
  if (profiter) profiter.addEventListener('click', function () {
    noter('gagne');
    window.location.href = '/discount/' + CODE + '?redirect=' + encodeURIComponent(window.location.pathname);
  });
})();
